import createIcon from '../../createIcon';

/**
 * @component @name PausePresentation
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMTkuMUgzVjVIMjFWMTkuMVpNMjEgM0gzQzEuOSAzIDEgMy45IDEgNVYxOUMxIDIwLjEgMS45IDIxIDMgMjFIMjFDMjIuMSAyMSAyMyAyMC4xIDIzIDE5VjVDMjMgMy45IDIyLjEgMyAyMSAzWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTkgOEgxMVYxNkg5VjhaTTEzIDhIMTVWMTZIMTNWOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PausePresentation = createIcon('PausePresentation', [
  [
    'path',
    {
      d: 'M21 19.1H3V5H21V19.1ZM21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3Z',
      key: 'wy1fpu',
    },
  ],
  ['path', { d: 'M9 8H11V16H9V8ZM13 8H15V16H13V8Z', key: '1ebpt1' }],
]);

export default PausePresentation;
